// @flow
import React from 'react';
import {SkipToContentMenuAnchor} from '@homeaway/react-skip-to-content-menu';
import {injectIntl} from 'react-intl';

import type {IntlShape} from 'react-intl';

type Props = {
    menuItemLabel?: string,
    anchorLabel?: string,
    id: string,
    intl: IntlShape
};

const LINGUA_KEYS = {
    skipToSearchCriteria: 'skipToSearchCriteria.anchorLabel',
    skipToSearchResultsPagination: 'skipToSearchResultsPagination.anchorLabel',
    skipToSearchResults: 'skipToSearchResults.anchorLabel',
    skipToSiteWideNavigation: 'skipToSiteWideNavigation.anchorLabel'
};

const getAnchorLabelTranslation = (id) => {
    return {
        skipToSearchCriteria: LINGUA_KEYS.skipToSearchCriteria,
        skipToSearchResultsPagination:
            LINGUA_KEYS.skipToSearchResultsPagination,
        skipToSearchResults: LINGUA_KEYS.skipToSearchResults,
        skipToSiteWideNavigation: LINGUA_KEYS.skipToSiteWideNavigation
    }[id];
};

const ConnectedSkipToContentAnchor = ({
    menuItemLabel,
    anchorLabel,
    id,
    intl
}: Props) => {
    const {formatMessage} = intl;
    const skipToContentProps = {
        id,
        menuItemLabel: menuItemLabel || formatMessage({id, defaultMessage: id}),
        anchorLabel:
            anchorLabel ||
            formatMessage({
                id: getAnchorLabelTranslation(id),
                defaultMessage: id
            })
    };
    return <SkipToContentMenuAnchor {...skipToContentProps} />;
};

export default injectIntl(ConnectedSkipToContentAnchor);
